import { FunctionUtils } from "@sharedcommon/util/functions.util";
import { CalculationStatus } from "@sharedcommon/model/calculation-status.model";

export class CalculationStatusService {
  private static readonly calcStatusToStrCode: Map<CalculationStatus, string> = new Map<CalculationStatus, string>([
    [ CalculationStatus.BlockBeforeCalc, "msg.common.calculation-status.block-before-calc" ],
    [ CalculationStatus.BlockAfterCalc, "msg.common.calculation-status.block-after-calc" ],
    [ CalculationStatus.Valid, "msg.common.calculation-status.valid" ],
    [ CalculationStatus.WaitingForCalculation, "msg.common.calculation-status.waiting-for-calculation"]
  ]);
  private static readonly EMPTY_STATUS_CODE = "msg.common.calculation-status.empty" ;

  /**
   * Check if the calculation status is valid
   * @param calcStatus the calculation status
   * @returns true if calculation is valid
   */
  static isCalcStatusValid(calcStatus: CalculationStatus): boolean {
    return calcStatus === CalculationStatus.Valid ;
  }

  /**
   * Check if the calculation status is empty
   * @param calcStatus the calculation status
   * @returns true if calculation is empty
   */
  static isCalcStatusEmpty(calcStatus: CalculationStatus): boolean {
    return FunctionUtils.isNotDefined(calcStatus) ;
  }

  /**
   * Check if the calculation status is blocked before calculation
   * @param calcStatus the calculation status
   * @returns true if calculation is blocked before calculation
   */
  static isCalcStatusBlockedBeforeCalc(calcStatus: CalculationStatus): boolean {
    return calcStatus === CalculationStatus.BlockBeforeCalc ;
  }

  /**
   * Check if the calculation status is blocked after calculation
   * @param calcStatus the calculation status
   * @returns true if calculation is blocked after calculation
   */
  static isCalcStatusBlockedAfterCalc(calcStatus: CalculationStatus): boolean {
    return calcStatus === CalculationStatus.BlockAfterCalc ;
  }

  /**
   * Return the key to transalte for a given calulation statue
   * @param calcStatus the caculation from what we want the translation key
   * @returns the corresponding tranlation ket
   */
  static returnCalculationStatusKeyMsg(calcStatus: CalculationStatus): string {
    return this.calcStatusToStrCode.get(calcStatus) || this.EMPTY_STATUS_CODE;
  }
}
